'use strict';

angular.module('clientDashboardApp').factory('userSnapService', function () {
    let initialized = false;

    return {
        init: function init() {
            if (!initialized) {
              var s = document.createElement("script");
              s.type = "text/javascript";
              s.async = true;
              s.src = '//api.usersnap.com/load/'+
                      '0fcbfe8b-1b1a-433b-93d8-521adb5bcca4.js';
              var x = document.getElementsByTagName('script')[0];
              x.parentNode.insertBefore(s, x);
              initialized = true;
            }
        }
    }
});

